import { Span, TextInput } from '@pandiafi/design-system'
import { Field, FieldProps } from 'formik'
import React, { ChangeEvent } from 'react'

import FormFieldWrapper from 'components/FormField'
import { BeneficiaryType } from 'views/TerminateContract/TerminateForm/initialValues'

interface BeneficiaryReturnPercentageFieldProps {
  index: number
  fieldName: 'returnPercentage' | 'rooReturnPercentage'
  label: string
  valueType: 'text' | 'number'
  required?: boolean
}

const nullableNumberFromInput = (
  event: ChangeEvent<HTMLInputElement>
): number | null =>
  Number.isNaN(event.currentTarget.valueAsNumber)
    ? null
    : event.currentTarget.valueAsNumber

export const BeneficiaryReturnPercentageField: React.FC<
  BeneficiaryReturnPercentageFieldProps
> = ({ index, fieldName, label, valueType, required }) => {
  return (
    <Field name={`beneficiaries[${index}]${fieldName}`}>
      {({
        field,
        form,
        meta,
      }: FieldProps<BeneficiaryType[typeof fieldName]>) => (
        <FormFieldWrapper
          name={field.name}
          required={required}
          label={label}
          className="min-tablet:mb-4"
          meta={meta}
          labelBold
        >
          <div className="inline-flex items-center gap-3">
            <TextInput
              {...field}
              type="number"
              value={field.value ?? ''}
              className="w-24 text-center"
              onChange={(event) => {
                if (valueType === 'number') {
                  void form.setFieldValue(
                    field.name,
                    nullableNumberFromInput(event)
                  )
                } else {
                  field.onChange(event)
                }
              }}
            />
            <Span large>%</Span>
          </div>
        </FormFieldWrapper>
      )}
    </Field>
  )
}
